module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-house-db0b2011e8a1e6a65a946dd38ecc8315.svg";